{
  "COMPOSE_REDIRECT": {
    "OPENING": "Ouverture d'une nouvelle conversation avec {email}…",
    "NO_EMAIL": "Aucune adresse e-mail fournie. Utilisez ?email=name@example.com",
    "CONTACT_ERROR": "Impossible de trouver le contact pour {email}."
  },
  "CONVERSATION": {
    "404": "Désolé, nous ne pouvons pas trouver la conversation. Veuillez réessayer",
    "IMAGE_RESIZE": {
      "SMALL": "Petite",
      "MEDIUM": "Moyenne",
      "LARGE": "Grande",
      "ORIGINAL": "Originale"
    },
    "SHOW_HIDDEN_MESSAGES": "Afficher les messages masqués",
    "SELECT_A_CONVERSATION": "Veuillez sélectionner une conversation à partir du panneau de gauche",
    "CSAT_REPLY_MESSAGE": "Veuillez évaluer la conversation",
    "SWITCH_VIEW_LAYOUT": "Changer la mise en page",
    "DASHBOARD_APP_TAB_MESSAGES": "Messages",
    "UNVERIFIED_SESSION": "L'identité de cet utilisateur n'est pas vérifiée",
    "NO_MESSAGE_1": "Oh oh ! Il semble qu'il n'y ait aucun message de clients dans votre boîte de réception.",
    "NO_MESSAGE_2": " pour envoyer un message à votre page !",
    "NO_INBOX_1": "Oh ! On dirait que vous n'avez pas encore ajouté de boîte de réception.",
    "NO_INBOX_2": " pour commencer",
    "NO_INBOX_AGENT": "Oh Oh ! Il semble que vous ne faites parti d'aucune boîte de réception. Veuillez contacter votre administrateur",
    "SEARCH_MESSAGES": "Rechercher des messages dans les conversations",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Traduction",
    "EMPTY_STATE": {
      "CMD_BAR": "pour ouvrir le menu de commande",
      "KEYBOARD_SHORTCUTS": "pour afficher les raccourcis clavier"
    },
    "SEARCH": {
      "TITLE": "Rechercher des messages",
      "RESULT_TITLE": "Résultats de recherche",
      "LOADING_MESSAGE": "Traitement des données ...",
      "PLACEHOLDER": "Saisissez n'importe quel texte pour rechercher des messages",
      "NO_MATCHING_RESULTS": "Aucun résultat trouvé."
    },
    "TRANSCRIPT": {
      "SHOW": "Afficher la transcription complète",
      "HIDE": "Masquer la transcription complète",
      "DOWNLOAD": "Télécharger la transcription",
      "COPY": "Copier la transcription"
    },
    "INVISIBLE_TO_CUSTOMER": "Invisible pour le client",
    "SENT_VIA_EMAIL": "Également envoyé au contact par e-mail ({time})",
    "UNREAD_MESSAGES": "Messages non lus",
    "UNREAD_MESSAGE": "Message non lu",
    "CLICK_HERE": "Cliquez ici",
    "LOADING_INBOXES": "Chargement des boîtes de réception",
    "LOADING_CONVERSATIONS": "Chargement des conversations",
    "CANNOT_REPLY": "Vous ne pouvez pas répondre en raison de",
    "24_HOURS_WINDOW": "Restriction de fenêtre de message de 24 heures",
    "API_HOURS_WINDOW": "Vous ne pouvez répondre à cette conversation que dans les {hours} heures",
    "FACEBOOK_CANNOT_REPLY": "Si vous devez poursuivre cette conversation, ",
    "NOT_ASSIGNED_TO_YOU": "Cette conversation ne vous est pas assignée. Voulez-vous vous assigner cette conversation ?",
    "ASSIGN_TO_ME": "M’assigner la conversation",
    "PENDING_WITH_BOT_BANNER": "Cette conversation est gérée par un bot IA. Si vous souhaitez répondre, ouvrez d'abord la conversation.",
    "INBOX_DELETE_REQUESTED_BANNER": "Cette boîte de réception est marquée pour suppression, la réponse du client n'arriverait donc jamais. Déplacez la conversation vers une autre boîte de réception pour répondre.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ce contact a une autre conversation ouverte #{id}",
      "MULTIPLE": "Ce contact a d'autres conversations ouvertes ({count})",
      "OPEN": "Ouvrir",
      "SHOW": "Afficher"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Vous pouvez seulement répondre à cette conversation en utilisant un modèle de message en raison de",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Restriction de fenêtre de message de 24 heures",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "Ce compte Instagram a été migré vers la nouvelle boîte de réception du canal Instagram. Tous les nouveaux messages y apparaîtront. Vous ne pourrez plus envoyer de messages depuis cette conversation.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Impossible d'envoyer le message car le client n'est pas en ligne et la continuité par e-mail n'est pas disponible.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Le client n'est pas en ligne. Il peut ne pas recevoir les messages car la continuité par e-mail n'est pas disponible.",
    "REPLYING_TO": "Vous répondez à :",
    "REMOVE_SELECTION": "Supprimer la sélection",
    "DOWNLOAD": "Télécharger",
    "OPEN_FILE": "Ouvrir",
    "DOWNLOAD_ATTACHMENTS": "Tout télécharger",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Télécharger toutes les pièces jointes une par une",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Tout télécharger en ZIP",
    "ERROR_DOWNLOADING_FILE": "Erreur lors du téléchargement du fichier",
    "UNKNOWN_FILE_TYPE": "Fichier inconnu",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Avant l'envoi, effectuez :",
      "EXECUTE": "Exécuter",
      "RETRY": "Réessayer",
      "CONFIRM": "Exécuter maintenant ?",
      "CONFIRM_YES": "Oui, exécuter",
      "CONFIRM_NO": "Annuler",
      "RUNNING": "En cours…",
      "DONE": "Effectué",
      "CLAIM_DELAYED": "sera déposée une fois la commande livrée",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "NOUVELLE réclamation {reference} créée, {planned} est clôturée — modifiez le texte du brouillon",
        "NEW_CLAIM": "NOUVELLE réclamation {reference} créée au lieu de mettre à jour {planned} — modifiez le texte du brouillon",
        "OTHER_CLAIM": "Réclamation {reference} mise à jour au lieu de {planned} — modifiez le texte du brouillon",
        "EXISTING_CLAIM": "Aucune nouvelle réclamation créée, la réclamation existante {reference} a été mise à jour — modifiez le texte du brouillon",
        "OTHER": "Cela s'est déroulé autrement que prévu par le brouillon — modifiez le texte du brouillon"
      },
      "FAILED": "Échec",
      "UNREACHABLE": "Le bot est injoignable",
      "REQUEST_FAILED": "Impossible de lancer l'action, veuillez réessayer.",
      "ACTIONS": {
        "CANCEL_ORDER": "Annuler la commande",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Changer le paiement en contre-remboursement",
        "CREATE_CLAIM": "Déposer une réclamation",
        "CREATE_OR_UPDATE_CLAIM": "Déposer ou mettre à jour une réclamation",
        "EXTEND_ORDER_PICKUP_DATE": "Prolonger le délai de retrait"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Envoi des pièces jointes...",
    "REPLIED_TO_STORY": "A répondu à votre histoire",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "Ce message n'est pas pris en charge. Vous pouvez voir ce message sur l'application Facebook Messenger.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "Ce message n'est pas pris en charge. Vous pouvez voir ce message sur l'application Instagram.",
    "SUCCESS_DELETE_MESSAGE": "Le message a bien été supprimé",
    "FAIL_DELETE_MESSSAGE": "Impossible de supprimer le message ! Veuillez réessayez",
    "NO_RESPONSE": "Pas de réponse",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Demander au client de partager son numéro de téléphone WhatsApp",
      "PENDING_ACTION": "Demande d'informations de contact en attente",
      "STATES": {
        "PENDING": "En attente des informations de contact",
        "SHARED": "Numéro de téléphone partagé",
        "IDENTITY_CONFLICT": "Le numéro de téléphone nécessite une vérification"
      }
    },
    "RESPONSE": "Response",
    "RATING_TITLE": "Note",
    "FEEDBACK_TITLE": "Commentaires",
    "REPLY_MESSAGE_NOT_FOUND": "Message indisponible",
    "CARD": {
      "SHOW_LABELS": "Afficher les étiquettes",
      "HIDE_LABELS": "Masquer les étiquettes"
    },
    "HEADER": {
      "MORE": "Plus d'actions",
      "RESOLVE_ACTION": "Résoudre",
      "REOPEN_ACTION": "Ré-ouvrir",
      "OPEN_ACTION": "Ouvert",
      "OPEN": "Plus",
      "CLOSE": "Fermer",
      "DETAILS": "détails",
      "SNOOZED_UNTIL": "Reporter jusqu'à",
      "SNOOZED_UNTIL_TOMORROW": "Reporté jusqu'à demain",
      "SNOOZED_UNTIL_NEXT_WEEK": "Reporté jusqu'à la semaine prochaine",
      "SNOOZED_UNTIL_NEXT_REPLY": "Reporté jusqu'à la prochaine réponse",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "manqué",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Marquer comme en attente",
      "SNOOZE_UNTIL": "Reporter",
      "RESOLVE_WITHOUT_CSAT": "Résoudre sans CSAT",
      "SNOOZE": {
        "TITLE": "Reporter jusqu'à",
        "NEXT_REPLY": "Réponse suivante",
        "TOMORROW": "Demain",
        "NEXT_WEEK": "Semaine prochaine"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Reporter jusqu'à",
      "APPLY": "Reporter",
      "CANCEL": "Annuler"
    },
    "PRIORITY": {
      "TITLE": "Priorité",
      "OPTIONS": {
        "NONE": "Aucun",
        "URGENT": "Urgent",
        "HIGH": "Élevé",
        "MEDIUM": "Moyenne",
        "LOW": "Faible"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Aucun",
        "INPUT_PLACEHOLDER": "Sélectionner la priorité",
        "NO_RESULTS": "Aucun résultat trouvé",
        "SUCCESSFUL": "La priorité de la conversation id {conversationId} a été changée en {priority}",
        "FAILED": "Impossible de modifier la priorité. Veuillez réessayer."
      }
    },
    "SLA": {
      "BREACHED": "dépassé"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Ouvrir dans un nouvel onglet",
      "COPY_LINK": "Copier le lien de la conversation",
      "COPY_LINK_SUCCESS": "Lien de la conversation copié dans le presse-papiers",
      "PENDING": "Marquer comme en attente",
      "RESOLVED": "Marquer comme résolu",
      "MARK_AS_UNREAD": "Marquer comme non lu",
      "MARK_AS_READ": "Marquer comme lu",
      "REOPEN": "Reprendre la conversation",
      "SNOOZE": {
        "TITLE": "Reporter",
        "NEXT_REPLY": "Jusqu’à la prochaine réponse",
        "TOMORROW": "Jusqu'à demain",
        "NEXT_WEEK": "Jusqu'à la semaine prochaine"
      },
      "ASSIGN_AGENT": "Assigner un agent",
      "ASSIGN_LABEL": "Assigner une étiquette",
      "AGENTS_LOADING": "Chargement des agents...",
      "ASSIGN_TEAM": "Assigner une équipe",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Conversation id {conversationId} assignée à \"{agentName}\"",
          "FAILED": "Impossible d'assigner l'agent. Veuillez réessayer."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Impossible d'assigner l'étiquette. Veuillez réessayer."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Équipe assignée «{team}» à la conversation id {conversationId}",
          "FAILED": "Impossible d'assigner l'équipe. Veuillez réessayer."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Signature du message",
      "ENABLE_SIGN_TOOLTIP": "Activer la signature",
      "DISABLE_SIGN_TOOLTIP": "Désactiver la signature",
      "INSERT_SIGNATURE": "Insérer la signature dans l'éditeur",
      "SIGNATURE_PREVIEW_IMAGE": "(signature image)",
      "MSG_INPUT": "Maj + entrée pour une nouvelle ligne. Commencez par '/' pour sélectionner une réponse standardisée.",
      "PRIVATE_MSG_INPUT": "Maj + entrée pour une nouvelle ligne. Cela ne sera visible que par les agents",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "La signature du message n'est pas configurée, veuillez le configurer dans les paramètres du profil.",
      "CLICK_HERE": "Cliquez ici pour mettre à jour",
      "WHATSAPP_TEMPLATES": "Modèles WhatsApp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "La fenêtre WhatsApp de 24 heures a expiré. Répondez avec un modèle."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Votre réponse semble être en {draftLanguage}, mais cette conversation est en {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Traduire",
      "REPLY": "Répondre",
      "PRIVATE_NOTE": "Note privée",
      "SEND": "Envoyer",
      "SEND_EMAIL": "Envoyer un e-mail",
      "SEND_SMS": "Envoyer un SMS",
      "NO_SMS_INBOX": "Ajoutez une boîte de réception SMS pour envoyer des réponses par SMS.",
      "SEND_CHAT": "Envoyer un chat",
      "CREATE": "Ajouter une note",
      "INSERT_READ_MORE": "En savoir plus",
      "DISMISS_REPLY": "Annuler la réponse",
      "REPLYING_TO": "Répondre à:",
      "REPLY_TO_THIS": "Répondre à ceci",
      "TIP_EXPAND_ICON": "Agrandir l'éditeur",
      "TIP_COLLAPSE_ICON": "Réduire l'éditeur",
      "TIP_FORMAT_ICON": "Afficher l'éditeur de texte enrichi",
      "HEADING_LEVEL": {
        "LABEL": "Style de texte",
        "NORMAL": "Texte normal",
        "H1": "Titre 1",
        "H2": "Titre 2",
        "H3": "Titre 3"
      },
      "EDITOR": {
        "BOLD": "Gras",
        "ITALIC": "Italique",
        "UNDERLINE": "Souligné",
        "TEXT_COLOR": "Couleur du texte",
        "BG_COLOR_LABEL": "Couleur de fond",
        "FONT_SIZE_LABEL": "Taille de police",
        "FONT_SIZE": {
          "XS": "Petite",
          "SM": "Moyenne petite",
          "MD": "Par défaut",
          "LG": "Grande",
          "XL": "Très grande",
          "XXL": "Énorme"
        },
        "CODE": "Code",
        "LINK": "Ajouter ou supprimer un lien",
        "CREATE_LINK": "Créer un lien",
        "SAVE_LINK": "Enregistrer",
        "CANCEL": "Annuler",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Annuler",
        "REDO": "Rétablir",
        "BULLET_LIST": "Liste à puces",
        "ORDERED_LIST": "Liste numérotée",
        "BLOCKQUOTE": "Citation",
        "H1": "Titre 1",
        "H2": "Titre 2",
        "H3": "Titre 3",
        "IMAGE_UPLOAD": "Importer une image",
        "CLEAR_FORMATTING": "Effacer la mise en forme",
        "COLOR": {
          "RED": "Rouge",
          "YELLOW": "Jaune",
          "BLUE": "Bleu",
          "ROSE_RED": "Rouge rosé",
          "DEEP_CYAN": "Cyan foncé",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistache",
          "PURPLE": "Violet",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Argent",
          "NAVY": "Bleu marine",
          "OLD_PINK": "Vieux rose",
          "AQUA": "Turquoise",
          "BROWN": "Marron",
          "OLIVE": "Olive",
          "GOLD": "Or",
          "BEIGE": "Beige",
          "WINE": "Bordeaux",
          "FOREST": "Vert forêt",
          "GREEN": "Vert",
          "BLUE_GREY": "Gris bleu",
          "RUBY_RED": "Rouge rubis",
          "CHESTNUT_BROWN": "Marron châtaigne",
          "ASH_GREY": "Gris cendré"
        },
        "BG_COLOR": {
          "RED": "Rouge",
          "YELLOW": "Jaune",
          "BLUE": "Bleu",
          "ROSE_RED": "Rouge rosé",
          "DEEP_CYAN": "Cyan foncé",
          "ORANGE": "Orange",
          "PISTACHIO": "Pistache",
          "PURPLE": "Violet",
          "FUCHSIA": "Fuchsia",
          "SILVER": "Argent",
          "NAVY": "Bleu marine",
          "OLD_PINK": "Vieux rose",
          "AQUA": "Turquoise",
          "BROWN": "Marron",
          "OLIVE": "Olive",
          "GOLD": "Or",
          "BEIGE": "Beige",
          "WINE": "Bordeaux",
          "FOREST": "Vert forêt",
          "GREEN": "Vert",
          "BLUE_GREY": "Gris bleu",
          "RUBY_RED": "Rouge rubis",
          "CHESTNUT_BROWN": "Marron châtaigne",
          "ASH_GREY": "Gris cendré"
        }
      },
      "TIP_EMOJI_ICON": "Montrer le sélecteur d'émoji",
      "TIP_ATTACH_ICON": "Joindre des fichiers",
      "TIP_AUDIORECORDER_ICON": "Enregistrer l'audio",
      "TIP_AUDIORECORDER_PERMISSION": "Autoriser l'accès à l'audio",
      "TIP_AUDIORECORDER_ERROR": "Impossible d'ouvrir l'audio",
      "DRAG_DROP": "Glissez et déposez ici pour lier",
      "START_AUDIO_RECORDING": "Démarrer l'enregistrement audio",
      "STOP_AUDIO_RECORDING": "Arrêter l'enregistrement audio",
      "EMAIL_HEAD": {
        "EDIT": "Modifier",
        "EXPAND": "Cc/Cci",
        "HIDE": "Masquer",
        "INCLUDE_ORIGINAL_MESSAGE": "Inclure le message original",
        "TO": "À",
        "ADD_BCC": "Ajouter cci",
        "EDIT_HEADERS": "Modifier",
        "HIDE_HEADER_EDITS": "Masquer les modifications",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "E-mails séparés par des virgules",
          "ERROR": "Veuillez saisir une adresse de courriel valide"
        },
        "BCC": {
          "LABEL": "CCI",
          "PLACEHOLDER": "E-mails séparés par des virgules",
          "ERROR": "Veuillez saisir une adresse de courriel valide"
        },
        "SUBJECT": {
          "LABEL": "OBJET",
          "PLACEHOLDER": "Objet de l'e-mail",
          "RE_PREFIX": "Re :"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variables indéfinies",
        "MESSAGE": "Vous avez {undefinedVariablesCount} variables indéfinies dans votre message : {undefinedVariables}. Voulez-vous quand même envoyer le message ?",
        "CONFIRM": {
          "YES": "Envoyer",
          "CANCEL": "Annuler"
        }
      },
      "COPILOT": {
        "Q": "Demander de l'aide au robot"
      }
    },
    "VISIBLE_TO_AGENTS": "Note privée : uniquement visible par vous et votre équipe",
    "CHANGE_STATUS": "Statut de la conversation modifié",
    "CHANGE_STATUS_FAILED": "Le changement de statut de la conversation a échoué",
    "CHANGE_AGENT": "Responsable de la conversation modifié",
    "CHANGE_AGENT_FAILED": "Échec du changement de responsable",
    "ASSIGN_LABEL_SUCCESFUL": "Étiquette attribuée avec succès",
    "ASSIGN_LABEL_FAILED": "Échec de l'attribution de l'étiquette",
    "CHANGE_TEAM": "L'équipe de conversation a été modifiée",
    "IMAGE_UPLOAD_ERROR": "Impossible de téléverser l'image, veuillez réessayer",
    "FILE_SIZE_LIMIT": "Le fichier dépasse la limite de {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} pour les pièces jointes",
    "DRAFT": {
      "FILE_TOO_LARGE": "Le fichier « {fileName} » ({fileSize}) est trop volumineux pour le stockage du brouillon et sera ignoré",
      "ATTACHMENT_SERIALIZATION_FAILED": "Échec de la sérialisation de la pièce jointe pour le stockage du brouillon",
      "STORAGE_QUOTA_EXCEEDED": "Quota de stockage dépassé. Brouillon enregistré sans pièces jointes",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Échec de l'enregistrement du brouillon même sans pièces jointes",
      "SAVE_FAILED": "Échec de l'enregistrement du brouillon de la conversation"
    },
    "MESSAGE_ERROR": "Impossible d'envoyer ce message, veuillez réessayer plus tard",
    "SENT_BY": "Envoyé par:",
    "BOT": "Bot",
    "SEND_FAILED": "Impossible d'envoyer le message ! Réessayez",
    "TRY_AGAIN": "Réessayer",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Sélectionner un agent",
      "REMOVE": "Supprimer",
      "ASSIGN": "Assigner"
    },
    "CONTEXT_MENU": {
      "COPY": "Copier",
      "REPLY_TO": "Répondre à ce message",
      "DELETE": "Supprimer",
      "CREATE_A_CANNED_RESPONSE": "Ajouter aux réponses préenregistrées",
      "TRANSLATE": "Traduire",
      "COPY_PERMALINK": "Copier le lien vers le message",
      "LINK_COPIED": "URL du message copiée dans le presse-papiers",
      "FORWARD": "Transférer",
      "FORWARD_ERROR": "Échec de la préparation du message transféré",
      "DELETE_CONFIRMATION": {
        "TITLE": "Êtes-vous sûr de vouloir supprimer ce message ?",
        "MESSAGE": "Vous ne pouvez pas annuler cette action",
        "DELETE": "Supprimer",
        "CANCEL": "Annuler"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Fil de commentaires",
      "EMPTY": "Aucun commentaire à afficher",
      "VIEW_TREE": "Afficher le fil de commentaires"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "La conversation a été marquée résolue par {userName}",
          "CONTACT_RESOLVED": "La conversation a été résolue par {contactName}",
          "OPEN": "La conversation a été ré-ouverte par {userName}",
          "PENDING": "La conversation a été marquée comme en attente par {userName}",
          "SNOOZED": "La conversation a été reportée par {userName}",
          "AUTO_RESOLVED": "La conversation a été marquée comme résolue par le système en raison de {duration} jours d'inactivité",
          "SYSTEM_AUTO_OPEN": "Le système a rouvert la conversation en raison d'un nouveau message entrant.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "La conversation a été marquée comme résolue par {userName} (sans CSAT)",
          "AUTO_RESOLVED_INACTIVE": "La conversation a été marquée comme résolue par le système en raison de {duration} heures d'inactivité",
          "AUTO_RESOLVED_EMPTY": "La conversation a été marquée comme résolue par le système car elle était vide.",
          "BLOCKED_CONTACT_RESOLVED": "Le système a résolu la conversation car le contact est bloqué.",
          "KAUFLAND_TICKET_CLOSED": "Le système a résolu la conversation car le ticket a été clôturé sur Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} fixe la priorité à {newPriority}",
          "UPDATED": "{userName} a modifié la priorité de {oldPriority} à {newPriority}",
          "REMOVED": "{userName} a supprimé la priorité"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} s'est auto-assigné cette conversation",
          "ASSIGNED": "Assigné à {assigneeName} par {userName}",
          "REMOVED": "Responsable de la conversation supprimé par {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assigné à {teamName} par {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Assigné à {assigneeName} via {teamName} par {userName}",
          "REMOVED": "Non assigné de {teamName} par {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} a ajouté {labels}",
          "REMOVED": "{userName} a supprimé {labels}"
        },
        "SLA": {
          "ADDED": "{userName} a ajouté la politique SLA {slaName}",
          "REMOVED": "{userName} a retiré la politique SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} a mis la conversation en sourdine",
        "UNMUTED": "{userName} a rétabli le son de la conversation",
        "CONTACT_BLOCKED": "{userName} a bloqué le contact",
        "CONTACT_UNBLOCKED": "{userName} a débloqué le contact",
        "AUTO_RESOLUTION_MESSAGE": "La conversation est résolue car elle est inactive depuis un certain temps. Veuillez démarrer une nouvelle conversation si vous avez besoin d'aide supplémentaire.",
        "DOMAIN_BLOCKED": "{userName} a bloqué tous les contacts pour un domaine donné",
        "DOMAIN_UNBLOCKED": "{userName} a débloqué tous les contacts pour un domaine donné",
        "MERGED": "{userName} a fusionné la conversation #{sourceId} dans cette conversation",
        "MOVED": "{userName} a déplacé cette conversation de la boîte de réception {sourceInboxName} à la boîte de réception {targetInboxName}",
        "MOVED_BY_ORDER": "Déplacée car les commandes du contact proviennent uniquement de la boutique {storeName} (dernière commande {orderId}), dont le robot répond dans cette boîte de réception.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "L'action d'envoi de message a été ignorée pour ce message de réponse automatique",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "L'automatisation a été ignorée car le contact est bloqué",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "L'automatisation \"{ruleName}\" n'a pas pu déplacer cette conversation de la boîte de réception {sourceInboxName} vers la boîte de réception {targetInboxName}, car les boîtes de réception ne sont pas compatibles.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "L'automatisation \"{ruleName}\" n'a pas pu déplacer cette conversation de la boîte de réception {sourceInboxName} vers la boîte de réception {targetInboxName}, car le contact n'a pas d'adresse e-mail.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "L'automatisation \"{ruleName}\" n'a pas pu envoyer de message : cette boîte de réception téléphonique ne peut pas envoyer de SMS car le compte n'a aucune boîte de réception SMS. La règle a été désactivée et les administrateurs ont reçu un e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "L'automatisation \"{ruleName}\" n'a pas pu envoyer de message : les pièces jointes ne peuvent pas être envoyées par SMS depuis cette boîte de réception. La règle a été désactivée et les administrateurs ont reçu un e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "La macro \"{macroName}\" n'a pas envoyé son message : cette boîte de réception téléphonique ne peut pas envoyer de SMS car le compte n'a aucune boîte de réception SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "La macro \"{macroName}\" n'a pas envoyé son message : les pièces jointes ne peuvent pas être envoyées par SMS depuis cette boîte de réception.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "La macro \"{macroName}\" n'a pas envoyé son message : le bot traite cette conversation. Ouvrez d'abord la conversation.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "La macro \"{macroName}\" n'a pas envoyé son message : cette boîte de réception est marquée pour suppression. Déplacez d'abord la conversation vers une autre boîte de réception.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "L'automatisation \"{ruleName}\" a envoyé un e-mail à {contactEmail} dans une nouvelle conversation [#{conversationId}]({conversationPath}) de la boîte de réception {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "L'automatisation \"{ruleName}\" a démarré cette conversation suite à la conversation [#{conversationId}]({conversationPath}) de la boîte de réception {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "L'automatisation \"{ruleName}\" n'a pas pu envoyer le message dans une nouvelle conversation de la boîte de réception {inboxName}, car le contact n'a pas d'adresse e-mail.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "L'automatisation \"{ruleName}\" a envoyé un SMS au {contactPhone} dans une nouvelle conversation [#{conversationId}]({conversationPath}) de la boîte de réception {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "L'automatisation \"{ruleName}\" n'a pas pu envoyer le SMS dans une nouvelle conversation de la boîte de réception {inboxName}, car le contact n'a pas de numéro de téléphone.",
        "AUTOMATION_RULE_TRIGGERED": "Règle d'automatisation \"{ruleName}\" déclenchée",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "La règle d'automatisation \"{ruleName}\" a désactivé la priorité automatique",
        "AUTOMATION_SKIP_AUTO_LABELING": "La règle d'automatisation \"{ruleName}\" a désactivé l'étiquetage automatique",
        "AUTOMATION_STOP_PROCESSING_RULES": "La règle d'automatisation \"{ruleName}\" a arrêté le traitement des règles suivantes",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Client"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "répondu ailleurs, a sonné {duration}",
            "NO_ANSWER": "sans réponse, a sonné {duration}",
            "REJECTED": "rejeté après {duration} de sonnerie"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Résolu automatiquement après {count} rappels infructueux",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Enregistrement de l'appel supprimé par {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Envoyer la transcription de la conversation",
    "DESC": "Envoyer une copie de la transcription de la conversation à l'adresse de courriel spécifiée",
    "SUBMIT": "Envoyer",
    "CANCEL": "Annuler",
    "SEND_EMAIL_SUCCESS": "La transcription du chat a été envoyée avec succès",
    "SEND_EMAIL_ERROR": "Une erreur est survenue, veuillez réessayer",
    "FORM": {
      "SEND_TO_CONTACT": "Envoyer la transcription au client",
      "SEND_TO_AGENT": "Envoyer la transcription à l'agent assigné",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Envoyer la transcription à une autre adresse de courriel",
      "EMAIL": {
        "PLACEHOLDER": "Entrez une adresse de courriel",
        "ERROR": "Veuillez saisir une adresse de courriel valide"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Salut 👋, Bienvenue sur {installationName}!",
    "DESCRIPTION": "Merci pour votre inscription. Nous souhaitons que vous tiriez le meilleur parti de {installationName}. Voici quelques actions que vous pouvez effectuer dans {installationName} pour rendre votre expérience agréable.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Consultez nos dernières mises à jour",
    "ALL_CONVERSATION": {
      "TITLE": "Toutes vos conversations en un seul lieu",
      "DESCRIPTION": "Visualisez toutes les conversations de vos clients dans un seul tableau de bord. Vous pouvez filtrer les conversations par le canal entrant, l'étiquette et le statut.",
      "NEW_LINK": "Cliquez ici pour créer une boîte de réception"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Invitez les membres de votre équipe",
      "DESCRIPTION": "Puisque vous vous apprêtez à parler à votre client, amenez vos coéquipiers pour vous aider. Vous pouvez inviter vos coéquipiers en ajoutant leurs adresses e-mail à la liste des agents.",
      "NEW_LINK": "Cliquez ici pour inviter un membre de l'équipe"
    },
    "LABELS": {
      "TITLE": "Organiser les conversations avec des labels",
      "DESCRIPTION": "Les labels fournissent un moyen plus facile de catégoriser votre conversation. Créez des étiquettes comme #demande-support, #question-facturation etc., afin que vous puissiez les utiliser dans une conversation plus tard.",
      "NEW_LINK": "Cliquez ici pour créer des tags"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agent Assigné",
    "SELF_ASSIGN": "M’assigner la conversation",
    "TEAM_LABEL": "Équipe assignée",
    "SELECT": {
      "PLACEHOLDER": "Aucun"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Données personnalisées",
      "ORDER_HISTORY": "Historique des commandes",
      "CONTACT_DETAILS": "Détails du contact",
      "CONVERSATION_ACTIONS": "Actions de conversation",
      "CONVERSATION_LABELS": "Étiquettes de conversation",
      "CONVERSATION_INFO": "Informations de la conversation",
      "CONTACT_ATTRIBUTES": "Attributs du contact",
      "PREVIOUS_CONVERSATION": "Conversations précédentes",
      "MACROS": "Macros",
      "RETINO_TICKETS": "Tickets Retino",
      "SHOPIFY_ORDERS": "Shopify Orders"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "En attente",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Aucune donnée trouvée",
    "LOAD_ERROR": "Impossible de charger les données. Veuillez réessayer plus tard."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Charger plus",
    "NO_RECORDS_FOUND": "Aucun ticket trouvé",
    "LOAD_ERROR": "Impossible de charger les tickets depuis {hookName}. Veuillez réessayer plus tard.",
    "NOT_SEARCHABLE": "L'e-mail du contact n'est pas défini.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Chargement...",
    "NO_ORDERS": "Aucune commande trouvée",
    "NOT_AVAILABLE": "Données client non disponibles",
    "EXPAND": "Ouvrir le profil client",
    "MORE_ITEMS": "+ {count} articles",
    "EXPEDITION_STATUS": "Statut d'expédition",
    "OPEN_DETAIL": "ouvrir le détail",
    "COPY_ORDER_ID": "Numéro de commande",
    "EXTERNAL_ID": "ID externe",
    "PAYMENT_TYPE": "Mode de paiement",
    "PAYMENT_DATE": "Date de paiement",
    "DELIVERY_PROVIDER": "Transporteur",
    "EXPECTED_DATE_OF_DELIVERY": "Livraison prévue",
    "DATE_OF_DELIVERY": "Livré le",
    "EXPEDITION_DATE": "Date d'expédition",
    "INTERNAL_NOTE": "Note de la boutique",
    "PACKAGE_NUMBER": "Colis"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Créer un attribut",
    "NO_RECORDS_FOUND": "Aucun attribut trouvé",
    "UPDATE": {
      "SUCCESS": "Attribut mis à jour avec succès",
      "ERROR": "Impossible de mettre à jour l'attribut. Veuillez réessayer plus tard"
    },
    "ADD": {
      "TITLE": "Ajouter",
      "SUCCESS": "Attribut ajouté avec succès",
      "ERROR": "Impossible d'ajouter l'attribut. Veuillez réessayer plus tard"
    },
    "DELETE": {
      "SUCCESS": "Attribut supprimé avec succès",
      "ERROR": "Impossible de supprimer l'attribut. Veuillez réessayer plus tard"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Ajouter des attributs",
      "PLACEHOLDER": "Rechercher des attributs",
      "NO_RESULT": "Aucun attribut trouvé"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "De",
    "TO": "À",
    "BCC": "Cci",
    "CC": "Cc",
    "SUBJECT": "Objet"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participe",
    "SIDEBAR_TITLE": "Participants à une conversation",
    "NO_RECORDS_FOUND": "Aucun résultat trouvé",
    "ADD_PARTICIPANTS": "Sélectionner des participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} autres utilisateurs",
    "REMANING_PARTICIPANT_TEXT": "+{count} autre",
    "TOTAL_PARTICIPANTS_TEXT": "{count} personnes participent.",
    "TOTAL_PARTICIPANT_TEXT": "{count} personne participe.",
    "NO_PARTICIPANTS_TEXT": "Personne ne participe !.",
    "WATCH_CONVERSATION": "Rejoindre une conversation",
    "YOU_ARE_WATCHING": "Vous participez",
    "API": {
      "ERROR_MESSAGE": "Impossible de mettre à jour, essayez à nouveau !",
      "SUCCESS_MESSAGE": "Participants mis à jour !"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Voir le contenu traduit",
    "DESC": "Vous pouvez voir le contenu traduit dans chaque langue.",
    "ORIGINAL_CONTENT": "Contenu original",
    "TRANSLATED_CONTENT": "Contenu traduit",
    "NO_TRANSLATIONS_AVAILABLE": "Aucune traduction n'est disponible pour ce contenu"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Quelqu'un est en train d'écrire"
  },
  "READING": {
    "ONE": "{user} lit ce ticket",
    "TWO": "{user} et {secondUser} lisent ce ticket",
    "MULTIPLE": "{user} et {count} autres lisent ce ticket"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Déplacer la conversation",
    "DESCRIPTION": "Déplacer cette conversation vers une autre boîte de réception e-mail.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "ID de la conversation"
    },
    "TARGET": {
      "TITLE": "Boîte de réception de destination",
      "PLACEHOLDER": "Sélectionner une boîte de réception e-mail",
      "NO_RESULTS": "Aucune autre boîte de réception e-mail disponible",
      "ERROR": "Veuillez sélectionner une boîte de réception de destination"
    },
    "SUBMIT": "Déplacer la conversation",
    "CANCEL": "Annuler",
    "SUCCESS_MESSAGE": "Conversation déplacée avec succès",
    "ERROR_MESSAGE": "Impossible de déplacer la conversation. Veuillez réessayer."
  },
  "MERGE": {
    "TITLE": "Fusionner les conversations",
    "DESCRIPTION": "Fusionner cette conversation avec une autre conversation. Tous les messages de cette conversation seront déplacés vers la conversation cible, et cette conversation sera supprimée.",
    "SOURCE": {
      "TITLE": "Conversation source (sera supprimée)",
      "ID_LABEL": "ID de la conversation"
    },
    "TARGET": {
      "TITLE": "Conversation cible",
      "PLACEHOLDER": "Saisissez l'ID de la conversation pour rechercher (ex. 123)",
      "HELP": "Entrez l'ID de la conversation dans laquelle fusionner tous les messages.",
      "ERROR": "Veuillez sélectionner une conversation cible"
    },
    "WARNING": "Attention : cette action est irréversible. Tous les messages seront déplacés vers la conversation cible et cette conversation sera supprimée définitivement.",
    "SUBMIT": "Fusionner les conversations",
    "CANCEL": "Annuler",
    "SUCCESS_MESSAGE": "Conversation fusionnée avec succès",
    "ERROR_MESSAGE": "Impossible de fusionner les conversations. Veuillez vérifier la conversation cible et réessayer.",
    "SEARCH": {
      "NO_RESULTS": "Aucune conversation trouvée avec cet ID",
      "ERROR_MESSAGE": "Impossible de rechercher des conversations. Veuillez réessayer."
    },
    "CONFIRM": {
      "TITLE": "Confirmer la fusion",
      "DESCRIPTION": "Êtes-vous sûr de vouloir fusionner cette conversation ? Cette action est irréversible.",
      "YES": "Oui, fusionner",
      "CANCEL": "Annuler"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
